export default "__VITE_ASSET__CZkHMyY3__"